// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "react-native";

// components
import Text from "../../Text";
import { emToPx } from "../../../libraries";

// constants
import theming from "../../../constants/theming";

const { useTheme } = theming;

type PropsType = {
  price;
  priceToRender: "booking" | "pricing";
  size?: "normal" | "sm";
};

const styles = StyleSheet.create({
  estimatePrice: {
    fontWeight: "500",
  },
  estimatedPrice__normal: {
    fontSize: emToPx(1.625),
  },
  estimatedPrice__sm: {
    fontSize: emToPx(1),
  },
});

const EstimatePrice: React.FunctionComponent<PropsType> = (props) => {
  const { price, priceToRender, size = "normal" } = props;

  const intl = useIntl();
  const theme = useTheme();

  return (
    <>
      <Text
        style={[
          styles.estimatePrice,
          styles[`estimatedPrice__${size}`],
          { color: theme.PRIMARY_COLOR_DARKEN },
        ]}
      >
        {"pricing" === priceToRender
          ? intl.formatMessage(
              {
                defaultMessage: "Votre séjour à partir de {amount}",
              },
              {
                amount: intl.formatNumber(price, {
                  style: "currency",
                  currency: "EUR",
                }),
              }
            )
          : intl.formatMessage(
              {
                defaultMessage: "Votre séjour à {amount}",
              },
              {
                amount: intl.formatNumber(price, {
                  style: "currency",
                  currency: "EUR",
                }),
              }
            )}
      </Text>
    </>
  );
};

export default EstimatePrice;
